module.exports = __webpack_public_path__ + "images/stickers/taco-alert@2x.60cf2c2b89c387f8c1ed.png";